import { pathToUrl } from '../../utils/router';
import { ApiRoutesEnum } from '../../utils/routes';

import { CandidateProjectMatchDetail } from './matching.types';
import { useMatchingRead } from './useMatchingRead';

export const useMatchDetails = (candidateUuid: string, projectUuid: string) =>
  useMatchingRead<CandidateProjectMatchDetail>(
    ['detail', candidateUuid, projectUuid],
    pathToUrl(ApiRoutesEnum.candidateProjectMatch, {
      candidateUuid: candidateUuid || 'missing',
      projectUuid: projectUuid || 'missing',
    }),
    !!candidateUuid && !!projectUuid
  );
